var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ResponsiveVideoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-top: ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  padding-top: ", ";\n"])), function (_a) {
    var paddingTop = _a.paddingTop;
    return paddingTop || '56.25%';
});
export var EmbeddedVideo = styled.iframe(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
export default {};
var templateObject_1, templateObject_2;
